// Helper function to get first two letters of name (uppercase)
const getFirstTwoLetters = (name) => {
  if (!name) return "";
  const trimmed = name.trim();
  return trimmed.substring(0, 2).toUpperCase();
};

/**
 * Generate site code based on type and hierarchy
 * @param {string} type - Type of site (warehouse, plant, branch, location)
 * @param {string} currentName - Name of current site
 * @param {string} companyCode - Company code
 * @param {string} plantName - Name of plant (for branch and location)
 * @returns {string} Generated site code
 */
export const generateSiteCode = (
  type,
  currentName,
  companyCode,
  plantName = null
) => {
  let siteCode = "ECOM";

  if (type === "warehouse") {
    // Main warehouse: ECOM-{company_code}
    siteCode = `ECOM-${companyCode}`;
  } else if (type === "plant") {
    // Plant code: ECOM-{company_code}-{first two letters of plant name}
    siteCode = `ECOM-${companyCode}-${getFirstTwoLetters(currentName)}`;
  } else if (type === "branch") {
    // Branch code: ECOM-{company_code}-{first two letters of plant name}-{first two letters of branch name}
    siteCode = `ECOM-${companyCode}-${getFirstTwoLetters(plantName)}-${getFirstTwoLetters(currentName)}`;
  }

  return siteCode;
};

export default generateSiteCode;
